module.exports = __webpack_public_path__ + "static/media/boletins_diarios.419b65eb.svg";